import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const reportApi = {
    //查詢收到的名片收錄請求
    "queryUserDataByDate": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record12/queryUserDataByDate`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                CompanyCode: null,
                month: 0
            }
        }
    },
    //查詢收到的名片收錄請求
    "queryUserCount": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record12/queryUserCount`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },
	//查詢瀏覽總數
	"queryVisitCount": {
	    send: (data, callback, failCallback, errorCallback) => {
	        postRequest(`${baseUrl.shopopeeHttp}record12/queryVisitCount`, data, callback, failCallback, errorCallback)
	    },
	    getParams: () => {
	        return {}
	    }
	},
	
	//查詢瀏覽人數詳情
	"queryVisitDataByDate": {
	    send: (data, callback, failCallback, errorCallback) => {
	        postRequest(`${baseUrl.shopopeeHttp}record12/queryVisitDataByDate`, data, callback, failCallback, errorCallback)
	    },
	    getParams: () => {
	        return {
	            CompanyCode: null,
	            month: 0
	        }
	    }
	},
}

export default reportApi